export function getPublicUrlFromS3Key(s3Key: string): string {
    const s3PublicBucket: string = `${process.env.REACT_APP_PUBLIC_CONTENT_BUCKET}`;
    return `https://${s3PublicBucket}.s3.amazonaws.com/${s3Key}`;
}
